module.exports = __webpack_public_path__ + "media/images/illustrations/level-9a2afe72032204f5d2643a40d22c6695.svg";